import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { HOME_PATH } from '~/constants';
import { useAuth } from '~/providers/AuthProvider';

export const AuthRedirect: FC = () => {
  const { token } = useAuth();
  return token ? <Navigate to={HOME_PATH} replace /> : <Outlet />;
};
